const pieSpec = {
  version: 1,
  filters: [],
  bucketColumn: null,
  sort: null, // can be "asc", "dsc" or "null"
  showLegend: null,
  legendTitle: null,
};

export default pieSpec;



// WEBPACK FOOTER //
// ./src/constants/Visualisation/pieSpecTemplate.js